import { getAllKnowledges } from '../api';
import { useFetch } from './useFetch';

export const useKnowledgeBase = (limit = 20) => {
  const { data: knowledgeData, loading } = useFetch(async () => {
    const knowledgeData = await getAllKnowledges({
      includeInactive: false,
      page: 1,
      limit,
      debug: false,
    });
    return knowledgeData?.tables.map(item => ({
      label: item.name,
      value: item.id,
    }));
  }, []);

  return {
    knowledgeData,
    loading,
  };
};
